var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 1.88867V5.33079C11.6673 5.7975 11.6673 6.03085 11.7581 6.20911C11.838 6.36592 11.9655 6.4934 12.1223 6.57329C12.3006 6.66412 12.5339 6.66412 13.0007 6.66412H16.4428M13.334 10.8307H6.66732M13.334 14.1641H6.66732M8.33398 7.4974H6.66732M11.6673 1.66406H7.33398C5.93385 1.66406 5.23379 1.66406 4.69901 1.93655C4.2286 2.17623 3.84615 2.55868 3.60647 3.02909C3.33398 3.56387 3.33398 4.26393 3.33398 5.66406V14.3307C3.33398 15.7309 3.33398 16.4309 3.60647 16.9657C3.84615 17.4361 4.2286 17.8186 4.69901 18.0582C5.23379 18.3307 5.93385 18.3307 7.33398 18.3307H12.6673C14.0674 18.3307 14.7675 18.3307 15.3023 18.0582C15.7727 17.8186 16.1552 17.4361 16.3948 16.9657C16.6673 16.4309 16.6673 15.7309 16.6673 14.3307V6.66406L11.6673 1.66406Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.85381c6c629a6d39673824038df5f236.svg";
export { ForwardRef as ReactComponent };